(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3199,8054,6260],{

/***/ 6560:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empresa",
      function () {
        return __webpack_require__(3218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ listingRearranger; },
/* harmony export */   "eS": function() { return /* binding */ contentRearranger; }
/* harmony export */ });
function contentRearranger(param) {
    var content = param.content, _useVideoAd = param.useVideoAd, useVideoAd = _useVideoAd === void 0 ? true : _useVideoAd, _adsOptions = param.adsOptions, adsOptions = _adsOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 4,
        positionDesktop: 4
    } : _adsOptions, _videoAdOptions = param.videoAdOptions, videoAdOptions = _videoAdOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 1,
        positionDesktop: 2
    } : _videoAdOptions, _shouldUseIdCountPosition = param.shouldUseIdCountPosition, shouldUseIdCountPosition = _shouldUseIdCountPosition === void 0 ? true : _shouldUseIdCountPosition;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var maxIdCountPosition = 10;
    if (length < adsOptions.positionMobile && length < adsOptions.positionDesktop) return content;
    var isValidDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionDesktop === 0 && i >= adsOptions.positionDesktop && i < length && adsOptions.enableDesktop;
    };
    var isValidMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionMobile === 0 && i >= adsOptions.positionMobile && i < length && adsOptions.enableMobile;
    };
    var shouldRenderVideoAdMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useVideoAd && videoAdOptions.enableMobile && i === adsOptions.positionMobile * videoAdOptions.positionMobile;
    };
    var shouldRenderVideoAdDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useVideoAd && videoAdOptions.enableDesktop && i === adsOptions.positionDesktop * videoAdOptions.positionDesktop;
    };
    var contentRearranged = [];
    var adMobileCount = 1;
    var adDesktopCount = 1;
    var adVideoM = {
        tipo: "adVideoGtmMobile"
    };
    var adVideoD = {
        tipo: "adVideoGtmDesktop"
    };
    content.forEach(function(block, i) {
        var adMobile = {
            tipo: "adMobile",
            idCountPosition: shouldUseIdCountPosition && adMobileCount <= maxIdCountPosition ? adMobileCount.toString() : ""
        };
        var adDesktop = {
            tipo: "adDesktop",
            idCountPosition: shouldUseIdCountPosition && adDesktopCount <= maxIdCountPosition ? adDesktopCount.toString() : ""
        };
        if (content.length >= 4 && i === 4) {
            contentRearranged.push({
                tipo: "cardCTA"
            });
        }
        if (i === 1) {
            contentRearranged.push(adMobile);
            adMobileCount += 1;
            contentRearranged.push(adDesktop);
            adDesktopCount += 1;
        }
        if (isValidMobile(i) && shouldRenderVideoAdMobile(i)) contentRearranged.push(adVideoM);
        if (isValidMobile(i) && !shouldRenderVideoAdMobile(i)) {
            if (adMobileCount <= maxIdCountPosition) contentRearranged.push(adMobile);
            if (adMobileCount <= maxIdCountPosition) adMobileCount += 1;
        }
        if (isValidDesktop(i) && shouldRenderVideoAdDesktop(i)) contentRearranged.push(adVideoD);
        if (isValidDesktop(i) && !shouldRenderVideoAdDesktop(i)) {
            if (adDesktopCount <= maxIdCountPosition) contentRearranged.push(adDesktop);
            if (adDesktopCount <= maxIdCountPosition) adDesktopCount += 1;
        }
        contentRearranged.push(block);
        if (content.length > 9 && i === 8) {
            contentRearranged.push({
                tipo: "readMore"
            });
        }
    });
    return contentRearranged;
}
var adsContainsMobile = {
    ads: true,
    mobile: true
};
var adsContainsDesktop = {
    ads: true,
    mobile: false
};
function listingRearranger(param) {
    var content = param.content, primary = param.primary, _hasNoAds = param.hasNoAds, hasNoAds = _hasNoAds === void 0 ? false : _hasNoAds, _sizeMobile = param.sizeMobile, sizeMobile = _sizeMobile === void 0 ? 3 : _sizeMobile, _sizeDesktop = param.sizeDesktop, sizeDesktop = _sizeDesktop === void 0 ? 6 : _sizeDesktop;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var result = [];
    if (!primary) {
        result.push(adsContainsDesktop);
    }
    var chunkified = [];
    content.forEach(function(element, index) {
        chunkified.push(element);
        if ((index + 1) % sizeMobile === 0 && index + 1 >= sizeMobile && !hasNoAds) chunkified.push(adsContainsMobile);
        if ((index + 1) % sizeDesktop === 0 && index + 1 >= sizeDesktop) {
            result.push({
                chunck: chunkified
            });
            if (index + 1 < length && !hasNoAds) result.push(adsContainsDesktop);
            chunkified = [];
        }
        if (chunkified.length > 0 && length === index + 1) {
            result.push({
                chunck: chunkified
            });
        }
    });
    return result;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    contentRearranger: contentRearranger,
    listingRearranger: listingRearranger
});


/***/ }),

/***/ 3666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





function Card(param) {
    var title = param.title, url = param.url, image = param.image, _chipText = param.chipText, chipText = _chipText === void 0 ? "ver detalhes" : _chipText, _rumor = param.rumor, rumor = _rumor === void 0 ? false : _rumor, _onlyImage = param.onlyImage, onlyImage = _onlyImage === void 0 ? false : _onlyImage, _onlyImageAndText = param.onlyImageAndText, onlyImageAndText = _onlyImageAndText === void 0 ? false : _onlyImageAndText, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("group flex min-h-[220px] w-full cursor-pointer flex-col items-center rounded-lg bg-mglGray50 no-underline transition-all duration-300", onlyImage || onlyImageAndText ? "p-0" : "p-4", fullWidth ? "w-full" : ""),
            title: title,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative flex aspect-video justify-center [&>figure>div>img]:object-contain", fullWidth ? "w-full" : onlyImageAndText || onlyImage ? "max-h-[240px]" : "max-h-[120px] "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: image.url,
                            blurhash: image.blurhash,
                            width: onlyImage || onlyImageAndText ? null : 100,
                            height: onlyImage || onlyImageAndText ? null : 100,
                            alt: title
                        }),
                        rumor && !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-[9.5em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-[0.6875rem] uppercase leading-loose text-mglGray50 hover:[&>div>span>svg>path>fill]:text-mglGray50",
                            children: "Rumor"
                        })
                    ]
                }),
                onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mt-4 font-medium text-mglGray900 tablet:mx-0 tablet:mb-0",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-10 items-center justify-center text-center text-sm font-medium text-mglGray900 no-underline",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    texto: chipText,
                    chipSize: "medium",
                    posIcon: "chevron-right",
                    color: "black",
                    borderColor: "black",
                    title: title,
                    className: "group-hover:border group-hover:border-mglGray900 group-hover:bg-mglGray900 group-hover:text-mglGray50 [&>span>svg]:transition-colors group-hover:[&>span>svg]:text-mglGray50"
                })
            ]
        })
    });
}


/***/ }),

/***/ 8054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LoadingLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function LoadingLogo(param) {
    var _hasTransparentBackground = param.hasTransparentBackground, hasTransparentBackground = _hasTransparentBackground === void 0 ? false : _hasTransparentBackground, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasGrayIcon = param.hasGrayIcon, hasGrayIcon = _hasGrayIcon === void 0 ? false : _hasGrayIcon;
    var variants = {
        LoaderLogoContainer: {
            hasTransparentBackground: {
                true: "bg-transparent",
                false: "bg-mglGray50"
            },
            isLoading: {
                true: "mb-8",
                false: "hidden"
            },
            hasGrayIcon: {
                true: "[&>div>div>svg]:fill-[#999] [&>div>div>svg]:stroke-[#999]",
                false: ""
            }
        },
        CtLogo: {
            hasTransparentBackground: {
                true: "fill-mglGray50",
                false: ""
            },
            isLoading: {
                true: "visible",
                false: "invisible"
            }
        },
        CtCircular: {
            hasTransparentBackground: {
                true: "stroke-mglGray50",
                false: ""
            },
            isLoading: {
                true: "visible",
                false: "invisible"
            }
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("grid h-24 pb-[50px] [grid-column-end:1] [grid-column-start:1] phone:[grid-column-end:3] desktop:pb-0 desktop:[grid-column-end:4]", variants.LoaderLogoContainer.hasGrayIcon[hasGrayIcon.toString()], variants.LoaderLogoContainer.hasTransparentBackground[hasTransparentBackground.toString()], variants.LoaderLogoContainer.isLoading[isLoading.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex h-auto w-full items-center justify-center p-2",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative mx-auto my-0 block h-[50px] w-[50px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("absolute left-[calc(50%-12px)] top-[calc(50%-9px)] h-[18px] w-[25px] fill-[#999]", variants.CtLogo.hasTransparentBackground[hasTransparentBackground.toString()], variants.CtLogo.isLoading[isLoading.toString()]),
                        viewBox: "0 0 26.64 18.84",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                            className: "inner",
                            points: "0 0 0 18.84 17.22 18.84 12.51 14.13 4.71 14.13 4.71 4.71 17.22 4.71 17.22 18.84 21.93 18.84 21.93 4.71 26.64 4.71 26.64 0 0 0"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("absolute bottom-0 left-0 right-0 top-0 m-auto h-[50px] w-[50px] animate-rotate stroke-[#999]", variants.CtCircular.hasTransparentBackground[hasTransparentBackground.toString()], variants.CtCircular.isLoading[isLoading.toString()]),
                        viewBox: "0 0 50 50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "absolute inset-0 box-border h-[50px] w-[50px] animate-pulse-loading rounded-half border-[4px] border-solid border-[#999]"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 6260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ InfiniteScrollComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function InfiniteScrollComponent(param) {
    var fetchMore = param.fetchMore;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
        };
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                observer.disconnect();
                fetchMore();
            }
        }, options);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: containerRef,
        style: {
            height: "1rem",
            marginBottom: "1rem"
        }
    });
}


/***/ }),

/***/ 4552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ PlaylistCardList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


var PlaylistCardList = function(param) {
    var children = param.children, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop;
    var variants = {
        paddingOnTop: {
            true: "pt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] grid-rows-1 gap-5 [grid-auto-columns:1fr]", variants.paddingOnTop[paddingOnTop.toString()]),
        children: children
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    PlaylistCardList: PlaylistCardList
});


/***/ }),

/***/ 3218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CompanyListing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Institutional/AdvertiseHere/FormModal/styles.tsx + 1 modules
var styles = __webpack_require__(1229);
// EXTERNAL MODULE: ./src/hooks/useOutsideClickRef.ts
var useOutsideClickRef = __webpack_require__(6425);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Layout/Title/index.tsx
var Title = __webpack_require__(9879);
// EXTERNAL MODULE: ./src/components/Layout/Card/index.tsx
var Card = __webpack_require__(3666);
// EXTERNAL MODULE: ./src/components/Ads/Rearrangers/index.ts
var Rearrangers = __webpack_require__(354);
// EXTERNAL MODULE: ./src/components/Layout/ObserverInfiniteScroll/index.tsx
var ObserverInfiniteScroll = __webpack_require__(6260);
// EXTERNAL MODULE: ./src/components/Layout/LoadingLogo/index.tsx
var LoadingLogo = __webpack_require__(8054);
// EXTERNAL MODULE: ./src/components/Listing/PlaylistCard/styles.tsx
var PlaylistCard_styles = __webpack_require__(4552);
;// CONCATENATED MODULE: ./src/components/Listing/CompaniesList/index.tsx








function CompaniesList(param) {
    var companies = param.companies;
    var rearrangedCompanies = (0,react.useMemo)(function() {
        return (0,Rearrangers/* listingRearranger */.MM)({
            content: companies,
            primary: true,
            hasNoAds: true,
            sizeMobile: 24,
            sizeDesktop: 24
        }).filter(function(arranged) {
            if ("chunck" in arranged) return true;
            return false;
        });
    }, [
        companies
    ]);
    var ref = (0,react.useState)(1), nextChunk = ref[0], setNextChunk = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var displayedCompanies = (0,react.useMemo)(function() {
        return rearrangedCompanies.slice(0, nextChunk).flatMap(function(chunk) {
            return chunk.chunck;
        });
    }, [
        rearrangedCompanies,
        nextChunk
    ]);
    var getMoreCompanies = function() {
        if (nextChunk >= rearrangedCompanies.length) return;
        setIsLoading(true);
        setNextChunk(function(prev) {
            return Math.min(prev + 1, rearrangedCompanies.length);
        });
        setIsLoading(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                color: "black",
                texto: "Todas as Empresas",
                headingTag: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaylistCard_styles/* PlaylistCardList */.o, {
                children: displayedCompanies.map(function(company) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        title: company.titulo,
                        url: company.url,
                        image: company.imagem,
                        chipText: "ver mais"
                    }, company.url);
                })
            }),
            nextChunk < rearrangedCompanies.length && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ObserverInfiniteScroll["default"], {
                fetchMore: getMoreCompanies
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLogo["default"], {
                isLoading: nextChunk < rearrangedCompanies.length,
                hasTransparentBackground: true
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Listing/CompaniesList/CompanySearch/index.tsx








function CompanySearch(param) {
    var companies = param.companies;
    var ref = (0,react.useState)(false), isSelectMenuOpen = ref[0], setIsSelectMenuOpen = ref[1];
    var ref1 = (0,react.useState)(""), companySelectValue = ref1[0], setCompanySelectValue = ref1[1];
    var selectRef = (0,useOutsideClickRef/* default */.Z)({
        setIsOpen: setIsSelectMenuOpen
    });
    (0,react.useEffect)(function() {
        if (companySelectValue && companySelectValue.length > 1 && !isSelectMenuOpen) {
            setIsSelectMenuOpen(true);
        }
        if (!companySelectValue || companySelectValue.length === 1) {
            setIsSelectMenuOpen(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        companySelectValue
    ]);
    var filteredOptions = companies.filter(function(option) {
        return option.titulo.toLowerCase().includes(companySelectValue.toLowerCase());
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-0 my-10 [&>svg]:absolute [&>svg]:left-2 [&>svg]:top-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "min-h-10 w-full rounded border border-solid border-mglGray400 bg-mglGray50 py-2 pl-8 pr-4 text-sm placeholder:text-mglGray500",
                        placeholder: "Pesquisar",
                        onChange: function(event) {
                            return setCompanySelectValue(event.target.value);
                        },
                        value: companySelectValue
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        icon: "mdi:magnify",
                        color: designSystemColors/* mglGray.mglGray500 */.Ce.mglGray500
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FormModalSelect */.uR, {
                        ref: selectRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* FormModalSelectOptions */.Wg, {
                            isOpen: isSelectMenuOpen,
                            children: filteredOptions.map(function(option) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: option.url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "block cursor-pointer p-2 text-[0.625rem] text-base text-mglGray900 transition-all duration-300 ease-ease hover:bg-mglBlue400 hover:text-mglGray50 focus:bg-mglBlue400 focus:text-mglGray50",
                                        title: "Ir para p\xe1gina de ".concat(option.titulo),
                                        children: option.titulo
                                    })
                                }, option.url);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesList, {
                companies: companies
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/v2/components/metatags/index.tsx



function robotsToString(robots) {
    var result = [];
    robots.index === undefined && (robots.index = true);
    if (!robots.index) {
        result.push("noindex");
        if (robots.follow === undefined) {
            robots.follow = false;
        }
    }
    if (!robots.follow) {
        result.push("nofollow");
    }
    if (robots.maxImagePreview) {
        result.push("max-image-preview:".concat(robots.maxImagePreview));
    }
    return result.join(", ") || null;
}
function Metatags(_param) {
    var titulo = _param.titulo, descricao = _param.descricao, dados = (0,_object_without_properties/* default */.Z)(_param, [
        "titulo",
        "descricao"
    ]);
    var autor = dados.autor || {
        nome: "Canaltech",
        twitter: "@canaltech"
    };
    var robots = robotsToString(dados.robots);
    var imagem = dados.imagem || {
        url: "https://img.canaltech.com.br/canaltech-512.png",
        largura: 512,
        altura: 512
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: descricao
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: descricao
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: descricao
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: autor.nome
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: autor.twitter
            }),
            dados.canonical && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: dados.canonical
            }),
            dados.ogURL && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: dados.ogURL
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "image",
                content: imagem.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: imagem.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:height",
                content: imagem.altura.toString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:width",
                content: imagem.largura.toString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: imagem.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: dados.imagem ? "summary_large_image" : "summary"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/v2/services/api.ts
/* provided dependency */ var process = __webpack_require__(3454);


var publicRuntimeConfig = config_default()().publicRuntimeConfig;
// SSR roda dentro do cluster: o host público (api.*.hml / api.staging) passa pelo
// ingress-nginx com PROXY protocol (LBaaS MGC) e o tráfego Pod→ExternalIP morre com
// ECONNRESET — mesmo motivo do dual-URL em src/services/api.ts. Em SSR usamos a URL
// interna do cluster (INTERNAL_API_V2, server-only); no browser mantemos o host
// público (publicRuntimeConfig). Sem INTERNAL_API_V2 definida (ex: produção), o
// fallback mantém o host público — comportamento inalterado.
var isServer = "object" === "undefined";
var apiV2BaseSSR = process.env.INTERNAL_API_V2 || publicRuntimeConfig.NEXT_PUBLIC_API_V2;
var api = axios_default().create({
    baseURL: isServer ? apiV2BaseSSR : publicRuntimeConfig.NEXT_PUBLIC_API_V2,
    timeout: 10000,
    responseType: "json"
});


;// CONCATENATED MODULE: ./src/pages/empresa/index.tsx












var __N_SSP = true;
function CompanyListing(param) {
    var responseData = param.responseData, navBarData = param.navBarData, ogURL = param.ogURL;
    var ref = (0,react.useState)(responseData.data.itens), companies = ref[0], setCompanies = ref[1];
    var ref1 = (0,react.useState)(responseData.data.paginacao), nextCursor = ref1[0], setNextCursor = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var handleLoadMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, newItems, newCursor, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!nextCursor || loading) return [
                            2
                        ];
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            api.get("/empresa/", {
                                params: {
                                    cursor: nextCursor
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent().data;
                        newItems = data.data.itens;
                        newCursor = data.data.paginacao;
                        setCompanies(function(prev) {
                            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(newItems));
                        });
                        setNextCursor(newCursor);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Erro ao carregar mais empresas", error);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoadMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        layoutData: {
            navBarData: navBarData,
            tagsData: null
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Metatags, {
                titulo: "Empresas de Tecnologia de A a Z - Canaltech",
                descricao: "Conhe\xe7a no Canaltech o cat\xe1logo de empresas de tecnologia de A a Z, contando um pouco sobre onde e por quem foram fundadas, al\xe9m da hist\xf3ria de cada uma delas.",
                robots: {
                    index: false,
                    maxImagePreview: "none"
                },
                ogURL: ogURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                hasBreadcrumb: true,
                backgroundColor: designSystemColors/* mglGray.mglGray200 */.Ce.mglGray200,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                        breadcrumbList: []
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearch, {
                        companies: companies
                    }),
                    nextCursor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            padding: "20px",
                            paddingBottom: "150px",
                            position: "relative",
                            zIndex: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: handleLoadMore,
                            disabled: loading,
                            style: {
                                padding: "10px 20px",
                                cursor: loading ? "not-allowed" : "pointer",
                                backgroundColor: "#fff",
                                border: "1px solid #ccc",
                                borderRadius: "4px"
                            },
                            children: loading ? "Carregando..." : "Carregar mais empresas"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "150px",
                            width: "100%",
                            display: "block",
                            clear: "both"
                        }
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,8802,7590,944,6869,9774,2888,179], function() { return __webpack_exec__(6560); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);